import { useState, useEffect } from "react";

export function useIsMobile() {
  const [width, setWidth] = useState(() => typeof window !== "undefined" ? window.innerWidth : 1200);

  useEffect(() => {
    const handler = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handler, { passive: true });
    return () => window.removeEventListener("resize", handler);
  }, []);

  return {
    isMobile: width < 640,
    isTablet: width < 1024,
    width,
  };
}
